module.exports = __webpack_public_path__ + "static/media/Raja.58b050d4.jpeg";